import React from "react";

export default function ProdukacjaCopyrightNote() {
    return <>
        <hr className='text-white'/>
        <p className='text-secondary-light px-3 pt-3 mb-1 text-center'>© 2025 Produkacja sp. z o. o.</p>
    </>
}